import * as THREE from 'three';

import { CameraConfig, Colors, LightsConfig, ScenesConfig } from '../../interfaces/3dViewer';


export const COLORS_CONFIG: Colors = {
  general: {
    background: 0xFFFFFF,  // base color for prostate
    prostate: 0x7CC0D9,
  },
  homunculus: {
    base: 0xb09b70,
    specular: 0x050505,
  },
  adenocarcinoma: {
    selected: 0xFF0000, // color applies if adenocarcinoma is available
    unselected: 0x6600cc,
  },
  nonAdenocarcinoma: {
    selected: 0x0000ff,
    unselected: 0xF0F9FA,
  },
  scores: {
    '0': 0xA396CB,  // colors codes applied based on the Different PI-RADS Score
    '1': 0xF4E375,
    '2': 0xE98D00,
    '3': 0xAD3E00,
    '4': 0x792900,
    '5': 0x4B1D01,
  },
  gleason: {
    'Benign': 0XB3B9DA,  // colors codes applied based on the Different Gleason Score
    '<=6': 0xFCE290,
    '7(3+4)': 0xEBB626,
    '7(4+3)': 0xDE7510,
    '8': 0xA63D21,
    '>=9': 0x5C1B2E,
  }
};

export const CAMERA_CONFIG: CameraConfig = {
  fov: 70,
  near: 1,
  far: 10000,
  position: { z: 100 }
};

export const LIGHTS_CONFIG: LightsConfig = {
  ambient: 0x505050,
  spot: 0xffffff,
};

export const SCENES_CONFIG: ScenesConfig = {
  homunculus: {
    width: 410,
    height: 75,
  }
};
